<div
  class="user-info-wrapper"
  rds-dropdown-toggle-icon-button
  [rdsMenuTriggerFor]="rdsMenu"
  #triggerIcon="rdsMenuTrigger"
  size="s"
  rdsTooltip="Log out"
  >
  <rds-avatar size="m">
    @if (!imgError) {
      <img rds-avatar-image [src]="this?.user?.picture" (error)="imgError = true"/>
    }
    @if (imgError) {
      <span rds-avatar-initials>{{ this?.user?.initials }}</span>
    }

    <rds-avatar-label>Hi, {{this?.user?.givenName}}!</rds-avatar-label>
    <rds-avatar-description>{{this?.user?.role}}</rds-avatar-description>
  </rds-avatar>

  <rds-menu #rdsMenu="rdsMenu" size="s" xPosition="before" backdrop="transparent">
    <div rds-menu-item rdsTooltip="When enabled, clicking a congress card opens a side drawer with full details. When disabled, details expand inline on the card.">
      <rds-switch
        [checked]="congressDrawerEnabled"
        (buttonChanged)="onCongressViewModeChange($event.checked)"
        size="s"
        labelPosition="before"
      >Congress detail drawer</rds-switch>
    </div>
    <div rds-menu-separator></div>
    <button rds-menu-item (click)="logout()">
      <rds-icon namespace="filled" icon="logoff"/>
      Log out
    </button>
  </rds-menu>
</div>